var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apply-header-con"},[_c('div',{staticClass:"apply-header"}),_vm._v(" "),_c('div',{staticClass:"apply-welcome-info"},[_c('h1',{staticClass:"info-welcome"},[_vm._v("欢迎来到"+_vm._s(_vm.webInfo.webName)+"！")])])])}
var staticRenderFns = []

export { render, staticRenderFns }